var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import capitalize from "@material-ui/core/utils/capitalize";
import { Box } from "../box";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
export var LogoComponentName = "CosmosLogo";
export var useLogoStyles = makeStyles(function (theme) {
    var defaultSize = {
        width: theme.typography.pxToRem(29),
        height: theme.typography.pxToRem(32),
    };
    var smallSize = {
        width: theme.typography.pxToRem(25),
        height: theme.typography.pxToRem(27),
    };
    var xsmallSize = {
        width: theme.typography.pxToRem(17),
        height: theme.typography.pxToRem(19),
    };
    return {
        root: __assign(__assign({ display: "inline-block", color: theme.palette.secondary.main }, defaultSize), { "& $svg": defaultSize }),
        colorDark: {
            color: theme.mixins.shadeOfColor("neutral", "base"),
        },
        colorLight: {
            color: theme.mixins.shadeOfColor("neutral", "lighter"),
        },
        colorWhite: {
            color: theme.palette.common.white,
        },
        svg: {
            display: "block",
        },
        sizeXsmall: __assign(__assign({}, xsmallSize), { "& $svg": xsmallSize }),
        sizeSmall: __assign(__assign({}, smallSize), { "& $svg": smallSize }),
    };
}, { name: LogoComponentName });
export var Logo = React.forwardRef(function (props, ref) {
    var classes = useLogoStyles(props);
    var className = props.className, size = props.size, color = props.color, propClasses = props.classes, rootProps = __rest(props, ["className", "size", "color", "classes"]);
    return (React.createElement(Box, __assign({}, { ref: ref }, { className: clsx(classes.root, size && classes["size" + capitalize(size)], color && classes["color" + capitalize(color)], className) }, rootProps),
        React.createElement("svg", { className: classes.svg, viewBox: "0 0 29 32" },
            React.createElement("g", { transform: "translate(-100.000000, -88.000000)", fill: "currentColor" },
                React.createElement("g", { transform: "translate(100.000000, 88.000000)" },
                    React.createElement("path", { d: "M22.9616476,25.864 L19.715652,15.9851429 L28.2126476,9.88133333 L17.7094918,9.88133333 L14.4633035,0.00285714286 L14.4623403,0.00019047619 L24.9670372,0.00019047619 L28.2139961,9.88038095 L28.2141888,9.88019048 L28.2168857,9.87866667 C30.1024528,15.6104762 28.160442,22.1297143 22.9616476,25.864 L22.9616476,25.864 L22.9616476,25.864 Z M5.96418875,25.864 L5.96149178,25.8659048 L14.4606065,31.9712381 L22.9616476,25.8641905 L14.4633035,19.7586667 L5.96418875,25.864 L5.96418875,25.864 L5.96418875,25.864 Z M0.711069704,9.87885714 L0.711069704,9.87885714 C-1.27389999,15.9209524 1.03027533,22.3232381 5.96245499,25.8651429 L5.96322555,25.8620952 L9.2096065,15.9838095 L0.714537237,9.88114286 L11.2151888,9.88114286 L14.4615697,0.00266666667 L14.4623403,0 L3.95706538,0 L0.711069704,9.87885714 L0.711069704,9.87885714 L0.711069704,9.87885714 Z" }))))));
});
